module.exports = __webpack_public_path__ + "img/credit-card-compare.1ed35a4.webp";